<template>
    <div>
        <div class="report-heading">
            <div class="text-left">
                <h1>
                    Report Title
                    <span class="period">
                        ({{ periodStart }} - {{ periodEnd }})
                    </span>
                </h1>
                <span class="report-description">
                    Report description here.
                </span>
            </div>

            <div class="text-right">
                <i class="timestamp">Results as of {{ timestamp }}</i>
            </div>
        </div>

        <b-card>
            <div id="report-body" class="w-100">
                <QTable
                    :columns="columns"
                    :data="tableData"
                    hide-bottom
                    :loading="isLoading"
                    class="mb-4"
                    :rows-per-page-options="[0]"
                    row-key="desc"
                >
                    <template v-slot:body-cell-desc="props">
                        <td :class="{ total: props.row.isTotal }">
                            {{ props.row.desc }}
                        </td>
                    </template>
                    <template v-slot:body-cell-value="props">
                        <td :class="{ total: props.row.isTotal }">
                            {{ _toCurrency(props.row.value) }}
                        </td>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>

<script>
import { QTable } from "quasar";
import "@/css/quasar-table.css";

export default {
    components: {
        QTable
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: moment(),
                    end: moment()
                };
            }
        }
    },
    data() {
        return {
            columns: [
                {
                    name: "colName",
                    field: "colUniqueName",
                    label: "Sample Column 1",
                    align: "left",
                    headerStyle: "width:500px; font-weight:bold;"
                },
                {
                    name: "colName2",
                    field: "colUniqueName2",
                    label: "Another Column",
                    align: "left"
                }
            ],
            tableData: [],
            isLoading: true
        };
    },
    computed: {
        timestamp() {
            return moment
                .tz(this._timeZone)
                .format(this.getDateFormat() + " hh:mm A");
        },
        periodStart() {
            if (this.data.start) {
                return this.data.start.format(this.getDateFormat());
            }
            return null;
        },
        periodEnd() {
            if (this.data.end) {
                return this.data.end.format(this.getDateFormat());
            }
            return null;
        }
    },
    /**
     * MUST HAVE beforeDestroy for
     * self.$root.$off("report-filter-date-range:refresh", self.fetchData);
     */
    async mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.isShowDateRange = true;

        await self._getSetting();
        self.data.start = moment().tz(self._timeZone).startOf("week");
        self.data.end = moment().tz(self._timeZone).endOf("day");
        self.data.from = moment().tz(self._timeZone).startOf("week").unix();
        self.data.to = moment().tz(self._timeZone).endOf("day").unix();
        self.fetchData();

        self.$root.$on("report-filter-date-range:refresh", self.fetchData);
        self.$root.$on("report-unique-name:refresh", function () {
            self.refresh = 1;
            self.fetchData();
        });

        window.scrollTo(0, 0);
    },
    methods: {
        fetchData() {
            this.isLoading = true;

            setTimeout(() => {
                this.isLoading = false;
                this.tableData = [
                    {
                        colUniqueName: "Value 1",
                        colUniqueName2: "Another Value 1"
                    },
                    {
                        colUniqueName: "Value 2",
                        colUniqueName2: "Another Value 2"
                    }
                ];
            }, 1000);
        }
    }
};
</script>

<style scoped>
.report-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 5px;
}
.report-heading .period {
    font-size: 0.7em;
}
th {
    font-weight: bold;
    white-space: nowrap;
}
.card-body {
    padding-top: 0;
    padding-bottom: 0;
}
.report-description {
    display: block;
    margin-bottom: 10px;
    font-style: italic;
}
.total {
    font-weight: bold;
    border-top: 3px double #e4e4e4;
}
</style>
